import { SupplyTab } from '../campaigns/supply/supplyRouteSearch';
import { brandsRouteSearchSchema } from '../campaigns/brands/brandsRouteSearch';
import { campaignsRouteSearchSchema } from '../campaigns/campaigns/campaignsRouteSearch';
import { lineItemsRouteSearchSchema } from '../campaigns/campaigns/lineItemsRouteSearch';
import { creativesRouteSearchSchema } from '../campaigns/creatives/creativesRouteSearch';
import { optionalTrimmedString } from '../../lib/routeSearch';
import { AgencyEditorMode } from './model';
import { CreativeTab } from '../campaigns/creatives/model';
export function agencyCampaignRouteSearchSchema(search: Record<string, unknown>) {
  const supplyTab = Object.values(SupplyTab).find((tab) => tab === search['supplyTab']);
  const term = optionalTrimmedString(search['search']);
  const editor = Object.values(AgencyEditorMode).find((mode) => mode === search['editor']);
  const creativeTab = Object.values(CreativeTab).find((tab) => tab === search['creativeTab']);
  const id = optionalTrimmedString(search['id']);
  const brand = optionalTrimmedString(search['brand']);
  const campaign = optionalTrimmedString(search['campaign']);
  const { agencies: _agencies, ...tableSearch } = {
    ...brandsRouteSearchSchema(search),
    ...campaignsRouteSearchSchema(search),
    ...lineItemsRouteSearchSchema(search),
    ...creativesRouteSearchSchema(search),
  };
  void _agencies;
  return {
    ...tableSearch,
    ...(supplyTab ? { supplyTab } : {}),
    ...(term ? { search: term } : {}),
    ...(editor ? { editor } : {}),
    ...(creativeTab ? { creativeTab } : {}),
    ...(id ? { id } : {}),
    ...(brand ? { brand } : {}),
    ...(campaign ? { campaign } : {}),
    ...(Number.isInteger(Number(search['page'])) && Number(search['page']) > 1
      ? { page: Number(search['page']) }
      : {}),
  };
}
